if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.productIdInput = this.form.querySelector('[name=id]');
            this.productIdInput.disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            if(this.productIdInput.value == ''){
                this.variantError();
                return
            }
            if(this.querySelector('.error-message')){
                this.querySelector('.error-message').remove();
            }
            this.removeErrorsBlock();
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.add('loading');
				})
			}
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
						this.triggerErrorEvent(response);
                        return;
                    }
					console.log(response)
					this.triggerSuccessEvent();
                    // Succses function
                    this.succses()
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
			console.log(resp)
            console.log(resp.description);
			let productInfo = this.closest('.product-form-wrapper')
			if(productInfo){
				let errorBlock = document.createElement('div');
				errorBlock.classList.add('product-error');
				errorBlock.innerHTML = resp.description
				if(this.closest('.product-form-wrapper').querySelector('.product-error')){
					this.closest('.product-form-wrapper').querySelector('.product-error').innerHTML = resp.description
				}else{
					productInfo.append(errorBlock);
				}
			}
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
				})
			}
			if(resp.status == 422){
				// this.succses();
			}
        }

        succses() {
            console.log("Success");
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
				})
			}
			let productInfo = this.closest('.product-form-wrapper')
			if(productInfo){
				let successBlock = document.createElement('div');
				successBlock.classList.add('product-success');
				successBlock.innerHTML = window.errors.added_to_cart
				if(this.closest('.product-form-wrapper').querySelector('.product-success')){
					this.closest('.product-form-wrapper').querySelector('.product-success').innerHTML = window.errors.added_to_cart
				}else{
					productInfo.append(successBlock);
				}
				setTimeout(function (){
					document.querySelector('.product-success').remove()
				},3000)
			}

			updateCartCount();

			// updateCartPopup();
			// if (document.querySelector('#cart-popup')) {
			// 	document.querySelector('#cart-popup').classList.add('open');
			// 	document.body.classList.add('disable-scroll');
			// }
			// if (document.querySelector('.cart-popup-overflow')) {
			// 	document.querySelector('.cart-popup-overflow').classList.add('open');
			// }
        }
        variantError(){
			const element = document.getElementById('size-select');
			if (element) {
				const offset = document.querySelector('header').offsetHeight + 50;
				const elementRect = element.getBoundingClientRect().top;
				const bodyRect = document.body.getBoundingClientRect().top;
				const offsetPosition = elementRect - bodyRect - offset;
				if (window.innerWidth <= 767) {
					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}
        }
        removeErrorsBlock(){
			if(this.closest('.product-info')){
				if(this.closest('.product-info').querySelector('.product-error')){
					this.closest('.product-info').querySelector('.product-error').remove();
				}
			}
        }

        errorPopup(text){
			console.log(text)
        }
		getFormQuantity(){
			let quantityInput = this.form.querySelector('[name="quantity"]') || document.querySelector(`input[form="${this.form.getAttribute('id')}"][name="quantity"]`);
			let quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

			if (Number.isNaN(quantity) || quantity < 1) {
				quantity = 1;
			}

			return quantity;
		}
		triggerSuccessEvent(){

			if(document.querySelector(`input[form="${this.form.getAttribute('id')}"]`)){
				let quantity = this.getFormQuantity();
				let event = new CustomEvent("theme:product_added", { detail:{ quantity: quantity } });
				document.dispatchEvent(event);
			}

		}
		triggerErrorEvent(error){

			if(document.querySelector(`input[form="${this.form.getAttribute('id')}"]`)){
				let quantity = this.getFormQuantity();
				let status = error && error.status ? parseInt(error.status, 10) : null;
				let message = error && error.message ? error.message : '';
				let description = error && error.description ? error.description : '';
				let event = new CustomEvent("theme:product_error", {
					detail:{
						quantity: quantity,
						status: status,
						message: message,
						description: description
					}
				});
				document.dispatchEvent(event);

				if (window.newrelic && typeof window.newrelic.addPageAction === 'function') {
					window.newrelic.addPageAction('add_to_cart_error', {
						product_form_id: this.form.getAttribute('id') || '',
						quantity: quantity,
						status: status === null ? 'unknown' : status,
						message: message,
						description: description
					});
				}
			}

		}

    });
}
